(function (angular) {
    'use strict'; 
    angular.module('Common')      
        .factory('permittedChannels', ['channelsProvider','permissionService', function(channelsProvider, permissionService){

            var fac = {
                canRead: canRead,
                canWrite: canWrite
            };

            function canRead(channelId){
                let havePermissions = channelsProvider[channelId].permissionsRead && channelsProvider[channelId].permissionsRead.length>0 ? permissionService.checkPermissions(channelsProvider[channelId].permissionsRead) : true;
                return havePermissions && channelsProvider[channelId].allowed;
                
            }

            function canWrite(channelId){
                let havePermissions = channelsProvider[channelId].permissionsWrite && channelsProvider[channelId].permissionsWrite.length>0 ? permissionService.checkPermissions(channelsProvider[channelId].permissionsRead) : true;
                return havePermissions && channelsProvider[channelId].allowed;
            }

            return fac;
        }]);

})(window.angular);